import React from 'react';

interface ERupiVoucherErrorProps {
  error: string;
}

const ERupiVoucherError: React.FC<ERupiVoucherErrorProps> = ({ error }) => {
  return (
    <div className="max-w-7xl mx-auto px-7 py-4">
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700 text-sm">
        {error}
      </div>
    </div>
  );
};

export default ERupiVoucherError;

